import DropdownIconController from "./dropdown_icon_controller";

export default class extends DropdownIconController {
  static targets = [ "badge" ];

  initialize() {
    super.initialize();
  }

  connect() {
    super.connect();
    this.updateBadge();
    this.startKeepingBadgeUpdated();
  }

  disconnect() {
    super.disconnect();
    this.stopKeepingBadgeUpdated();
  }

  handleClick(event) {
    if (this.iconTarget.contains(event.target)
      && this.dropdownContentTarget.classList.contains("hidden")) {
      this.loadNotifications();
    }
    super.handleClick(event);
  }

  loadNotifications() {
    this.fetchForTarget(window.App.prefixedUrl(`/notifications/current?platform=web`), this.dropdownContentTarget)
      .then(() => {
        App.$iconify.scanDOM();
      });
  }

  updateBadge() {
    this.fetchForTarget(window.App.prefixedUrl(`/notifications/badge?platform=web`), this.badgeTarget);
  }

  startKeepingBadgeUpdated() {
    let controller = this;
    this.updateBadgeInterval = setInterval(function() {
      controller.updateBadge();
    }, 20 * 1000);
  }

  stopKeepingBadgeUpdated() {
    if (this.updateBadgeInterval) {
      clearInterval(this.updateBadgeInterval);
    }
  }
}